import React, { Fragment } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { TableCell, Tooltip } from '@mui/material';
import { fetchUserDevices, changeOrderAndOrderBy, changePage, setDeviceType, setFilter } from '#action/user/devices-popup';
import DevicesCountListButton from '#component/general/devices-count-list-button';
import HighlightWord from '#component/general/highlight-word';
import LogsButton from '#component/user/dashboard/icon-button/show-log';
import EditButton from '#component/user/dashboard/icon-button/edit';
import { getHighlightedSearchResult } from '#component/general/highlight-word/helper';
import {
  BlockedIcon,
  DevicesTableCell,
  LinkStyle,
  NameTableCell,
  PersonIcon,
  UserCell,
  WarningIcon,
  EditCell,
  LogsCell
} from '#component/user/dashboard/table/styles';

export const FirstAndLastNameCell = ({ data: u }) => {
  const firstAndLastName = `${u.firstName} ${u.lastName}`;
  const filter = useSelector(s => s.listFilter, shallowEqual) ?? {};
  const highlightedSearchResult = getHighlightedSearchResult(filter);
  return (
    <NameTableCell align="left">
      <Tooltip
        title={u.withoutProjects ? 'User without projects' : ''}
      >
        <UserCell>
          {u.withoutProjects ? (
            <WarningIcon />
          ) : null}
          {u.disabled ? (
            <BlockedIcon />
          ) : (
            <PersonIcon />
          )}
          {highlightedSearchResult ? <HighlightWord
            textToHighlight={firstAndLastName}
            searchWord={highlightedSearchResult}
          /> : firstAndLastName}
        </UserCell>
      </Tooltip>
    </NameTableCell>
  );
};

export const DevicesCell = ({ data: u }) => {
  const devicePopupProps = {
    customActions: {
      fetchDevices: fetchUserDevices,
      changeOrderAndOrderBy,
      changePage,
      setDeviceType,
      setFilter
    },
    data: {
      userId: u.id
    }
  };
  return (
    <DevicesTableCell align="left">
      <div>
        <DevicesCountListButton
          devicesCount={u.devices}
          project={u.project}
          user={u}
          devicePopupProps={devicePopupProps}
        />
      </div>
    </DevicesTableCell>
  );
};

export const ProjectsCell = ({ data: u }) => {
  const filter = useSelector(s => s.listFilter, shallowEqual) ?? {};
  const highlightedSearchResult = getHighlightedSearchResult(filter);
  return ((
    <TableCell align="left">
      {u.project ? (
        u.project.map((project, index, self) => (
          <Fragment key={project.id}>
            <LinkStyle
              to={`/project/edit/${project.id}`}
              key={project.id}
            >
              {highlightedSearchResult ? <HighlightWord
                textToHighlight={project.title}
                searchWord={highlightedSearchResult}
              /> : project.title}
            </LinkStyle>
            {index !== self.length - 1 ? ', ' : ''}
          </Fragment>
        ))
      ) : null}
    </TableCell>
  ));
};

export const EmailCell = ({ data: u }) => {
  const filter = useSelector(s => s.listFilter, shallowEqual) ?? {};
  const highlightedSearchResult = getHighlightedSearchResult(filter);
  return (
    <LogsCell>
      {highlightedSearchResult ? <HighlightWord
        textToHighlight={u.email}
        searchWord={highlightedSearchResult}
      /> : u.email}
    </LogsCell>
  );
};

export const UserLogsCell = ({ data: u }) => (
  <LogsCell>
    <LogsButton user={u} />
  </LogsCell>
);

export const UserEditCell = ({ data: u }) => (
  <EditCell align="right">
    <EditButton user={u} />
  </EditCell>
);
